module.exports = {
  reserveApiUrl: "http://localhost:3232"
};
